export default __webpack_public_path__ + "bd064299a3414272d6aa0a0ad3482bea.jpg";